import { render, staticRenderFns } from "./OrderComplaintFinish.vue?vue&type=template&id=d743ab04&"
import script from "./OrderComplaintFinish.vue?vue&type=script&lang=ts&"
export * from "./OrderComplaintFinish.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports